import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AssetOrderListMobileComponent } from './components-mobile/asset-order-list-mobile/asset-order-list-mobile.component';
import { AssetOrderWidgetMobileComponent } from './components-mobile/asset-order-widget-mobile/asset-order-widget-mobile.component';
import { AssetListMobileComponent } from './components-mobile/asset-list-mobile/asset-list-mobile.component';
import { AssetTransferListMobileComponent } from './components-mobile/asset-transfer-list-mobile/asset-transfer-list-mobile.component';
import { AssetTransferWidgetMobileComponent } from './components-mobile/asset-transfer-widget-mobile/asset-transfer-widget-mobile.component';
import { AssetInventoryWidgetMobileComponent } from './components-mobile/asset-inventory-widget-mobile/asset-inventory-widget-mobile.component';
import { AssetDashboardComponent } from './components/asset-dashboard/asset-dashboard.component';
import { AssetProductCategoryListComponent } from './components/asset-product-category-list/asset-product-category-list.component';
import { AssetProductListComponent } from './components/asset-product-list/asset-product-list.component';
import { AssetOrderListComponent } from './components/asset-order-list/asset-order-list.component';
import { AssetListComponent } from './components/asset-list/asset-list.component';
import { AssetCallListComponent } from './components/asset-call-list/asset-call-list.component';
import { AssetTransferListComponent } from './components/asset-transfer-list/asset-transfer-list.component';
import { AssetInventoryListComponent } from './components/asset-inventory-list/asset-inventory-list.component';
import { TicketListComponent } from './components/ticket-list/ticket-list.component';
import { AssetTransferDirection } from './enums/asset-transfer-direction';
import { AssetTransferType } from './enums/asset-transfer-type';
import { AssetAssignmentListComponent } from './components/asset-assignment-list/asset-assignment-list.component';
import { AssetBarcodeComponent } from './components-mobile/asset-barcode/asset-barcode.component';
import { AssetShipmentListMobileComponent } from './components-mobile/asset-shipment-list-mobile/asset-shipment-list-mobile.component';
import { AssetShipmentListComponent } from './components/asset-shipment-list/asset-shipment-list.component';
import { TicketServiceListComponent } from './components/ticket-batch-list/ticket-batch-list.component';
import { TicketXtrnListComponent } from './components/ticket-xtrn-list/ticket-xtrn-list.component';


const routes: Routes = [

 { path: 'asset-order-mobile',                          component: AssetOrderListMobileComponent    },
 { path: 'asset-order-widget-mobile',                   component: AssetOrderWidgetMobileComponent  }, 
 { path: 'asset-list-mobile',                           component: AssetListMobileComponent         },
 { path: 'asset-transfer-list-mobile',                  component: AssetTransferListMobileComponent },
 
 { path: 'asset-transfer-from-branch-list-mobile',      component: AssetTransferListMobileComponent,  data:{assetTransferType : AssetTransferType.Transfer,    direction: AssetTransferDirection.input  }},
 { path: 'asset-transfer-to-branch-list-mobile',        component: AssetTransferListMobileComponent,  data:{assetTransferType : AssetTransferType.Transfer,    direction: AssetTransferDirection.output }},
 { path: 'asset-shipment-list-mobile',                  component: AssetShipmentListMobileComponent },

 { path: 'asset-barcode-mobile',                        component: AssetBarcodeComponent },
 
 /*
       this.assetOrderCode     = data['assetOrderCode'];
      this.direction          = data['direction'];
      this.assetTransferType  = data['assetTransferType'];
 */

 { path: 'asset-transfer-widget-mobile',   component: AssetTransferWidgetMobileComponent},
 { path: 'asset-inventoty-widget-mobile',  component: AssetInventoryWidgetMobileComponent},     
 

 { path: 'asset-dashboard',                component: AssetDashboardComponent},
 { path: 'asset-product-category-list',    component: AssetProductCategoryListComponent},
 { path: 'asset-product-list',             component: AssetProductListComponent},
 { path: 'asset-order',                    component: AssetOrderListComponent},
 { path: 'asset-list',                     component: AssetListComponent},
 { path: 'asset-call-list',                component: AssetCallListComponent},
 { path: 'asset-transfer-to-branch-list',  component: AssetTransferListComponent,  data:{assetTransferType : AssetTransferType.Transfer}},
 { path: 'asset-assignment-list',          component: AssetAssignmentListComponent},
 { path: 'asset-shipment-list',            component: AssetShipmentListComponent},

 { path: 'asset-inventory',                component: AssetInventoryListComponent},
 { path: 'asset-ticket',                   component: TicketListComponent}, 
 { path: 'asset-ticketBtach',              component: TicketServiceListComponent}, 

 { path: 'asset-ticket-xtrn',              component: TicketXtrnListComponent}, 

]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AssabilServicesRoutingModule { }
